export const img1 = [
    'https://websiteoss.ecoflow.com/upload/image/1749604866488/3_1_1.png',
    'https://websiteoss.ecoflow.com/upload/image/1749604868201/3_1_2.png',
];
export const img2 = [
    'https://websiteoss.ecoflow.com/upload/image/1749604867573/3_2_1.png',
    'https://websiteoss.ecoflow.com/upload/image/1749604866881/3_2_2.png',
];
export const img3 = [
    'https://websiteoss.ecoflow.com/upload/image/1749604867778/3_3_1.png',
    'https://websiteoss.ecoflow.com/upload/image/1749604867351/3_3_2.png',
];
export const img4 = [
    'https://websiteoss.ecoflow.com/upload/image/1749604867966/3_4_1.png',
    'https://websiteoss.ecoflow.com/upload/image/1749604866648/3_4_2.png',
];
export const img5 = [
    'https://websiteoss.ecoflow.com/upload/image/1749604867124/3_5_1.png',
    'https://websiteoss.ecoflow.com/upload/image/1749604868390/3_5_2.png',
];
export const img6 = {
    us: ['https://websiteoss.ecoflow.com/upload/image/1749605215512/3_6_1_us.png'],
    uk: ['https://websiteoss.ecoflow.com/upload/image/1749605216379/3_6_1_uk.png'],
    eu: ['https://websiteoss.ecoflow.com/upload/image/1749605215354/3_6_1_eu.png'],
};
export const img7 = {
    us: ['https://websiteoss.ecoflow.com/upload/image/1749605216114/3_7_1_us.png'],
    uk: ['https://websiteoss.ecoflow.com/upload/image/1749605216753/3_7_1_uk.png'],
    eu: ['https://websiteoss.ecoflow.com/upload/image/1749605216587/3_7_1_eu.png'],
};
export const img8 = [
    'https://websiteoss.ecoflow.com/upload/image/1749605215935/3_8_1.png',
    'https://websiteoss.ecoflow.com/upload/image/1749605215866/3_8_2.png',
];
